import * as React from "react";
import {option} from "ts-option";
import Modal from "../../../ui/modal/Modal";
import SingleFileSelector from "../../../file/SingleFileSelector";
import {ImportResult} from "../../../../model/importResult/ImportResult";
import {notifyBugsnagAndShowToast} from "../../../../utils/Utils";
import Toast from "../../../helper/Toast";
import {api} from "../../../../api/api";

interface IComponentProps {
	/**
	 * On modal close.
	 */
	onClose: () => void;
	/**
	 * Partner brand identifier
	 */
	partnerBrandId: string
}

interface IState {
	/**
	 * Indicates if files are uploading
	 */
	filesUploading: boolean;
	/**
	 * Upload errors to display
	 */
	errors: string[];
}

type Props = IComponentProps

export default class ImportPartnerBrandCustomersAndLeadsModal extends React.PureComponent<Props, IState> {

	constructor(props: Props) {
		super(props);
		this.state = {filesUploading: false, errors: []};
		this.uploadFile = this.uploadFile.bind(this);
	}

	render() {
		return (
			<Modal onCloseClicked={this.props.onClose} title={"Import Customers and Leads"}>
				<SingleFileSelector onUpload={this.uploadFile}
									onCancel={this.props.onClose}
									errors={option(this.state.errors)}
									filesUploading={this.state.filesUploading}
									onDropValidate={this.onDropValidate}/>
			</Modal>
		);
	}

	onDropValidate = (file: File) => {
		if (file.size > 1048576) {
			this.setState({errors: ["Selected file is too big (over 1MB)"]});
		}
		else {
			this.setState({errors: []})
		}
	}

	uploadFile(file: File) {
		if (file) {
			this.setState({filesUploading: true}, () => {
				api.instance.partnerBrandApi.importCustomersAndLeads(this.props.partnerBrandId, file)
					.then(() => {
						Toast.success("Customers and Leads uploaded successfully.", "Customers and Leads upload");
						this.setState({filesUploading: false}, this.props.onClose);
					})
					.catch((error: any) => {
						let errors: string[] = []
						if (error.response && error.response.status === 400) {
							errors = ImportResult.fromJson(error.response.data).error;
						}
						else {
							notifyBugsnagAndShowToast(error, "Customers and Leads upload")
						}
						this.setState({errors, filesUploading: false});
					});
			});
		}
	}
}

